define('TavanoTeamStaging.Feedback.Form.View', [
  'Backbone',
  'Backbone.FormView',
  'TavanoTeamStaging.Feedback.Model',
  'tavanoteamstaging_feedback_form.tpl',
  'GlobalViews.Message.View',
  'underscore',
  'jQuery'
], function(
  Backbone,
  BackboneFormView,
  FeedbackModel,
  tavanoteamstaging_feedback_form_tpl,
  MessageView,
  _,
  jQuery
) {
  'use strict';

  return Backbone.View.extend({
    template: tavanoteamstaging_feedback_form_tpl,

    title: _('Feedback').translate(),

    initialize: function(options) {
      this.application = options.application;
      this.container = options.container;
      this.model = new FeedbackModel();
      BackboneFormView.add(this);
    },

    events: {
      'submit form': 'customSaveForm'
    },

    bindings: {
      '[name="name"]': 'name',
      '[name="email"]': 'email',
      '[name="message"]': 'message'
    },

    customSaveForm: function(e) {
      jQuery('.feedback-form .global-views-message').parent().remove();

      self = this;
      var promise = BackboneFormView.saveForm.apply(this, arguments);

      e && e.preventDefault();

      return promise && promise.then(
        function(success) {
          if (success.code === 200) {
            self.cleanFields();
            jQuery('div[data-type="feedback-success-message"]').removeClass('hidden');
          }
        }, function(fail) {
          fail.preventDefault = true;

          // _.each(fail.responseJSON.errorMessage, function(message, field) {
          //   self.showMessage(message, 'error', field);
          // });

          self.showMessage('An error ocurred, please try again', 'error');
        }
      );
    },

    showMessage: function(message, type, field) {
      var messageView = new MessageView({
        message: message,
        type: type
      });

      if (typeof field !== 'undefined') {
        this.application.getLayout().$('[data-input="' + field + '"]').append(messageView.render().$el);
      } else {
        this.application.getLayout().$('.feedback-form').append(messageView.render().$el);
      }
    },

    getContext: function getContext() {
      return {
        model: this.model
      }
    },

    cleanFields: function() {
      this.model.set('name', '');
      this.model.set('email', '');
      this.model.set('message', '');
      this.render();
    }
  });
});
